import {ApiRequestor} from "@/classes/requestors/api.requestor";

export class DtoApiDeleteContact extends ApiRequestor {
  async $delete(contactId, teamId = null) {
    return this.$http('DELETE', `ticketContacts/${contactId}`, { params: { teamId }});
  }
}
